import EventSpeaker from './EventsSpeaker';

const EventsActivitySpeakers = ({ content, t }) => {
    return (
        <div className="speaker-wrp w-full bg-black1 text-black my-[60px] umd:my-[35px] usm:!my-[30px]">
            <div className="w-full text-center pt-[30px] text-h5">
                <p>/ {t('SPEAKER_INTRO')} /</p>
            </div>
            <div className="speaker-container w-full flex flex-shrink-0 flex-wrap py-[30px] gap-x-[40px] gap-y-[27px] justify-center">
                {content?.map((item, i) => (
                    <EventSpeaker key={`speaker_${i}`} item={item} />
                ))}
            </div>
        </div>
    );
};

export default EventsActivitySpeakers;
